import { HttpClient } from '@adapters/HttpClient';
import { MarketingApiResponse, MarketingFilters } from '../models';

export class MarketingApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getMarketingReport(filters?: MarketingFilters): Promise<MarketingApiResponse> {
    const params: Record<string, any> = {};

    if (filters) {
      if (filters.ref_date) {
        params.ref_date = filters.ref_date;
      }
      if (filters.country_id !== undefined) {
        params.country_id = filters.country_id;
      }
      if (filters.customer_origin && filters.customer_origin.length > 0) {
        params['customer_origin[]'] = filters.customer_origin;
      }
    }

    const response = await this.httpClient.get<MarketingApiResponse>(
      '/report/marketing',
      params
    );

    return response;
  }
}